module.exports = __webpack_public_path__ + "img/history6.c7d71176.jpg";